var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "Modal2",
        {
          staticClass: "cancel-plan-resources-modal",
          attrs: { showFooter: false, showTitle: false },
          on: {
            cancel: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "resources-container" },
            [
              _c("h3", { staticClass: "modal-title" }, [
                _vm._v(_vm._s(_vm.modalTitle)),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "alert-text" }, [
                _vm._v(_vm._s(_vm.infoMessage)),
              ]),
              _vm._v(" "),
              _vm.isSupsis
                ? [
                    _vm.users.length
                      ? _c(
                          "div",
                          { staticClass: "list" },
                          _vm._l(_vm.users, function (user) {
                            return _c(
                              "div",
                              { key: user._id, staticClass: "list-item" },
                              [
                                _c("div", { staticClass: "item-info" }, [
                                  _c("span", { staticClass: "item-name" }, [
                                    _vm._v(_vm._s(user.name)),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "item-email" }, [
                                    _vm._v(_vm._s(user.email)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "item-actions" },
                                  [
                                    _c("SupsisButton", {
                                      attrs: {
                                        size: "small",
                                        danger: "",
                                        icon: "delete",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onDeleteUser(user)
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "SupsisButton",
                                      {
                                        attrs: {
                                          size: "small",
                                          ghost: "",
                                          icon: user.enable
                                            ? "radio_button_checked"
                                            : "radio_button_unchecked",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDeactivateUser(user)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              user.enable ? "Aktif" : "Pasif"
                                            ) +
                                            "\n                        "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : _c("div", { staticClass: "no-item-text" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.noDeletableUserFound"))
                          ),
                        ]),
                  ]
                : [
                    _vm.channelsList.length
                      ? _c(
                          "div",
                          { staticClass: "list" },
                          _vm._l(_vm.channelsList, function (channel) {
                            return _c(
                              "div",
                              { key: channel._id, staticClass: "list-item" },
                              [
                                _c("div", { staticClass: "item-info" }, [
                                  _c("span", { staticClass: "item-name" }, [
                                    _vm._v(
                                      _vm._s(
                                        channel.name ||
                                          _vm.formatChannelType(channel.type)
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "item-type" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatChannelType(channel.type)
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "item-actions" },
                                  [
                                    _c("SupsisButton", {
                                      attrs: {
                                        size: "small",
                                        danger: "",
                                        icon: "delete",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onDeleteChannel(channel)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : _c("div", { staticClass: "no-item-text" }, [
                          _vm._v("Silinebilir bir kanal bulunamadı."),
                        ]),
                  ],
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }